var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-06-07
 * @brief SEI 체크시트 Management 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, reloadSpg, userInfoLoginState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import dayjs from "dayjs";
import { useAsync } from "react-async";
import { Trans } from "react-i18next";
import { alertState } from "../../../recoil/assessmentState";
import { checkSheetInfo, checkSheetState, compState } from "../../../recoil/menuState";
import { useTrans } from "../../../utils/langs/useTrans";
import EhpPagination from "../../common/pagination/EhpPagination";
function CheckSheetView(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const checksheet = useRecoilValue(checkSheetState);
    const setSheetInfo = useSetRecoilState(checkSheetInfo);
    const reload = useRecoilValue(reLoad);
    const [reLoadSpg, setReloadSpg] = useRecoilState(reloadSpg);
    const [comps, setComps] = useRecoilState(compState);
    //props
    const { handleOpenPop, checksheetName, WorkModes } = props;
    //
    const [chnanTree, setChnanTree] = useState(null);
    const [memoInfo, setMemoInfo] = useState(null);
    const [errorList, setErrorList] = useState([]);
    const [popInfo, setPopInfo] = useState(false);
    const [sheetItem, setSheetItem] = useState([]);
    const [companyItem, setCompanyItem] = useState([]);
    const [company, setCompany] = useState(null);
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    useEffect(() => {
        //등록
        handleOpenPop("pop-ss-add", _jsx(CheckSpgPop, { checksheetName: checksheetName, popInfo: popInfo, setPopInfo: setPopInfo, errorList: errorList, setErrorList: setErrorList, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-ss-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        handleOpenPop("pop-memo", _jsx(MemePop, { memoInfo: memoInfo, setMemoInfo: setMemoInfo, errorList: errorList, setErrorList: setErrorList, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-memo") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, {}));
    }, [popInfo, errorList, memoInfo]);
    function Close(id) {
        setPopInfo(true);
        CUTIL.jsclose_Popup(id);
    }
    // 검색
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "checksubtypeName",
        searchText: "",
    });
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "updatedTime",
        sort: "desc",
    });
    let appPath = `?checktypeName=${checksheet.sheetType}&spgName=${checksheet.spgName}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    // 정렬
    if (sortData.sortField.length > 0) {
        appPath = appPath + "&sort=" + sortData.sortField + "," + sortData.sort;
    }
    //checksheet Tree
    // 검색 필드
    if (company) {
        appPath = appPath + `&companyIds=${company.id}`;
    }
    // 검색 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&checksubtypeName=${searchTextField.searchText}`;
    }
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktype/checksubtypes${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + reLoadSpg,
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChnanTree(checksheet);
                setSheetItem(data.body);
                setPageInfo(Object.assign({}, data.data.page /* psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false  */)); //5, 10; //5, 10
                if (comps.id > 0) {
                    CompanyClick(comps);
                }
                if (chnanTree && chnanTree !== checksheet) {
                    handleCurPage(0);
                    setSortData({
                        sortField: "updatedTime",
                        sort: "desc",
                    });
                    setSearchText("");
                    setSearchTextField({
                        searchField: "checksubtypeName",
                        searchText: "",
                    });
                    WorkModes("VIEW");
                    if (companyData && checksheet.sheetType == checksheetName[1]) {
                        setComps({
                            companyId: "",
                            companyName: "",
                            id: -1,
                        });
                        const recom1 = document.getElementById("comSel");
                        const recom2 = document.getElementById("comSel0");
                        recom1.click();
                        recom2.click();
                    }
                }
            }
        }
    }, [data, chnanTree]);
    //고객향 점검 company
    const { data: companyData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktype/companies`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: reLoadSpg,
    });
    useEffect(() => {
        if (companyData) {
            if (companyData.codeNum == CONST.API_200) {
                setCompanyItem(companyData.body);
                if (reLoadSpg) {
                    handleCurPage(0);
                    setReloadSpg(false);
                }
            }
        }
    }, [companyData, reLoadSpg]);
    // 검색 버튼 이벤트
    function goSearch(e) {
        setSearchTextField(Object.assign(Object.assign({}, searchTextField), { searchText: searchText }));
        handleCurPage(0);
    }
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    function CheckSheetList(e, item) {
        if (e.target.nodeName !== "BUTTON") {
            WorkModes("LIST");
            setSheetInfo({
                checkversionId: item.recentVersionId,
                checkSubTypeId: item.checkSubTypeId,
                checkSubTypeName: item.checkSubTypeName,
                versionNo: item.recentVersionNo,
                enabled: item.enabled,
                description: item.description,
                count: item.countVersion,
                companyId: checksheet.sheetType == checksheetName[1] ? item.company.id : -1,
            });
        }
        else {
            setSheetInfo({
                checkversionId: item.recentVersionId,
                checkSubTypeId: item.checkSubTypeId,
                checkSubTypeName: item.checkSubTypeName,
                versionNo: item.recentVersionNo,
                enabled: item.enabled,
                description: item.description,
                count: item.countVersion,
                companyId: checksheet.sheetType == checksheetName[1] ? item.company.id : -1,
            });
        }
    }
    // 회사 유형 선택
    function CompanyClick(item) {
        setCompany(item);
    }
    function MemoPops(e, item) {
        setMemoInfo(item.description);
        CUTIL.jsopen_Popup(e);
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    return (_jsx(_Fragment, { children: sheetItem && (_jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements <= 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: `tbl__top ${checksheet == checksheetName[1] ? "mt-19" : ""}` }, { children: [checksheet.sheetType == checksheetName[1] && (_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-16" }, { children: _jsx("strong", { children: t("라벨.회사명") }) })), _jsxs("div", Object.assign({ id: "comSel", className: "select conpany w184", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsxs("div", Object.assign({ className: "selected-value" }, { children: [comps.id > 0 ? comps.companyName : !reLoadSpg ? t("라벨.전체") : "", " "] })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ id: "comSel0", className: "option", onClick: (e) => CompanyClick("") }, { children: t("라벨.전체") })), companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CompanyClick(item) }, { children: item.companyName }), "company_" + idx.toString())))] })] }))] })) })) }))), _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsx("div", Object.assign({ className: "searchinput" }, { children: _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.상세유형명입력"), onKeyDown: (e) => searchEnter(e), value: searchText, onChange: (e) => setSearchText(e.target.value) }), searchText.length > 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic ml-10 js-open", "data-pop": "pop-ss-add", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.상세유형추가") }) }))] })) }))] })), _jsx(Trans, Object.assign({ i18nKey: "체크시트관리.상새유형" }, { children: _jsxs("p", Object.assign({ className: "nodata__txt" }, { children: ["\uC0C1\uC138\uC720\uD615\uC774 \uC5C6\uC2B5\uB2C8\uB2E4. ", _jsx("br", {}), " \uC6B0\uCE21 \uC0C1\uB2E8 '\uC0C1\uC138\uC720\uD615 \uCD94\uAC00' \uBC84\uD2BC\uC744 \uB20C\uB7EC \uB4F1\uB85D\uD574\uC8FC\uC138\uC694."] })) })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uC0C1\uC138\uC720\uD615 \uBA85,\uCD5C\uC2E0 \uBC84\uC804,\uBC84\uC804 \uC218,\uD56D\uBAA9 \uC218,\uC218\uC815 \uB0A0\uC9DC,\uBA54\uBAA8,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8  \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8" }), checksheet.sheetType == checksheetName[0] ? (_jsxs("colgroup", { children: [_jsx("col", { style: { width: "30%" } }), _jsx("col", { style: { width: "18%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "10%" } })] })) : (_jsxs("colgroup", { children: [_jsx("col", { style: { width: "13%" } }), _jsx("col", { style: { width: "30%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "7%" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [checksheet.sheetType == checksheetName[1] && (_jsx("th", Object.assign({ scope: "col", className: "sort desc" }, { children: _jsx("span", { children: t("라벨.회사명") }) }))), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "checksubtypeName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("checksubtypeName") }, { children: _jsx("span", { children: t("라벨.상세유형") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "recentVersionNo" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("recentVersionNo") }, { children: _jsx("span", { children: t("라벨.최신버전") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.버전수") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.항목수") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.수정날짜") }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: t("라벨.메모") }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: t("라벨.삭제") }) }))] }) }), _jsx("tbody", { children: sheetItem.map((item, idx) => (_jsxs("tr", Object.assign({ onClick: (e) => CheckSheetList(e, item) }, { children: [checksheet.sheetType == checksheetName[1] && (_jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.company && item.company.companyName })) })), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.checkSubTypeName })) }), _jsx("td", { children: _jsxs("p", Object.assign({ className: "ellipsis" }, { children: [item.recentVersionNo, item.enabled ? "" : ` (${t("라벨.임시저장")})`] })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.countVersion })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.countCheckItem })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.updatedTime ? dayjs(item.updatedTime).format("YYYY-MM-DD") : "-" })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: `btn btn-comment js-open ${!item.description ? "icon-gray" : ""}`, "data-pop": "pop-memo", onClick: (e) => MemoPops(e, item) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBA54\uBAA8" })) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }), "sheetList_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "CHECKSHEET", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))) }));
}
export default CheckSheetView;
function CheckSpgPop(props) {
    const t = useTrans();
    //recoil
    const checksheet = useRecoilValue(checkSheetState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    //props
    const { checksheetName, popInfo, setPopInfo, errorList, setErrorList } = props;
    const [spgItem, setSpgItem] = useState([]);
    const [spg, setSpg] = useState(null);
    const [spgSel, setSpgSel] = useState(null);
    const [checkSubtypeName, setCheckSubtypeName] = useState("");
    const [checkSubtypeNameSel, setCheckSubtypeNameSel] = useState("");
    const [subMemo, setSubMemo] = useState("");
    const [subType, setSubType] = useState(false);
    const [companyItem, setCompanyItem] = useState([]);
    const [company, setCompany] = useState(null);
    const [companySel, setCompanySel] = useState(null);
    const [checkType, setCheckType] = useState("");
    const [checkTypeItem, setChecktypeItem] = useState([]);
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [versionInfo, setVersionInfo] = useState(null);
    const [description, setDescription] = useState("");
    const [checkTyped, setCheckTyped] = useState(true);
    const [checkSubed, setCheckSubed] = useState(true);
    const [checkVseioned, setCheckVersioned] = useState(true);
    //고객향 점검 company
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktype/companies`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCompanyItem(data.body);
                if (companySel) {
                    setCompanySel(companySel);
                }
                setCompanySel(data.body[0]);
                if (popInfo) {
                    setErrorList([]);
                    setSpg(null);
                    setCheckSubtypeName("");
                    setCheckSubtypeNameSel("");
                    setSubMemo("");
                    setSubType(false);
                    setCompany(null);
                    setCheckType("");
                    setVersionInfo(null);
                    setDescription("");
                    setPopInfo(false);
                    setCompanySel(null);
                    setSpgSel(null);
                }
            }
        }
    }, [data, popInfo]);
    /*
    // 진단 유형 선택
    function SheetClick(sheet) {
      if (popSheetName !== sheet) {
        setPopSheetName(sheet);
        setSpgType(true);
        setSpgItem([])
      }
    }
    */
    // 회사 유형 선택
    function CompanyClick(item, companyType) {
        if (checksheet.sheetType == checksheetName[0]) {
            setErrorList(errorList.filter((err) => err.field !== "companyId"));
            setCompany(item);
            setSpgSel(null);
            setCheckSubtypeNameSel("");
            setCheckType("");
            setVersionInfo(null);
            setDescription("");
            setCheckTyped(false);
            setCheckSubed(false);
            setCheckVersioned(false);
        }
        else {
            if (companyType == 1) {
                setErrorList(errorList.filter((err) => err.field !== "companyId"));
                setCompany(item);
            }
            else if (companyType == 2) {
                setErrorList(errorList.filter((err) => err.field !== "companySelId"));
                setCompanySel(item);
            }
            setSpgSel(null);
            setCheckSubtypeNameSel("");
            setCheckType("");
            setVersionInfo(null);
            setDescription("");
            setCheckTyped(false);
            setCheckSubed(false);
            setCheckVersioned(false);
        }
    }
    // 점검 유형에 대한 select
    function SpgSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${checksheet.sheetType == checksheetName[0] ? company.companyId : companySel.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgItem(data.body);
                }
                else {
                    // alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    function SpgSleClick(item) {
        setErrorList(errorList.filter((err) => err.field !== "spgSel"));
        setSpgSel(item);
        setCheckSubtypeNameSel("");
        setCheckType("");
        setVersionInfo(null);
        setDescription("");
        setCheckTyped(false);
        setCheckSubed(false);
        setCheckVersioned(false);
    }
    // 상세 유형 명 input
    function SubTypeChange(e) {
        setErrorList(errorList.filter((err) => err.field !== "checkSubtypeName"));
        setCheckSubtypeName(e.target.value);
    }
    // 불러오기 on||off
    function CheckSubType(e) {
        if (!subType) {
            setSubType(true);
        }
        else {
            setErrorList([]);
            setSpg(null);
            setCheckSubtypeNameSel("");
            setSubType(false);
            setCompany(null);
            setCheckType("");
            setVersionInfo(null);
            setDescription("");
            setSubType(false);
        }
        setErrorList([]);
    }
    // 진단 유형
    function CheckTypes(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktypes?companySpgId=${spgSel.companySpgId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setChecktypeItem(data.body);
                    setCheckTyped(true);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 상세 유형
    function CheckTypeSub(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setCheckSubed(true);
            setErrorList(errorList.filter((err) => err.field !== "checkType"));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheckSubtypeItem(data.body);
                    setCheckType(type);
                    setCheckSubtypeNameSel("");
                    setVersionInfo(null);
                    setDescription("");
                    setCheckSubed(false);
                    setCheckVersioned(false);
                    setCheckSubed(true);
                    setCheckVersioned(true);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 버젼
    function CheckTypeVersion(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkSubtypeNameSel"));
            let data = null;
            // 상세 유형 초기화
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheckVersiontypeItem(data.body);
                    setCheckSubtypeNameSel(type.checkSubName);
                    setDescription(type.description ? type.description : "");
                    setCheckVersioned(false);
                    setVersionInfo(null);
                    setCheckVersioned(true);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 버젼 선택
    function CheckTypeVersionSel(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkVersionId"));
            setVersionInfo(type);
        });
    }
    // 등록
    function CheckSheetSaveed(e) {
        if (!subType) {
            if (checksheet.sheetType == checksheetName[0]) {
                if (!checkSubtypeName) {
                    setErrorList([
                        !checkSubtypeName && {
                            field: "checkSubtypeName",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                    ]);
                }
                else {
                    CheckSheetSave(checksheet.sheetType);
                }
            }
            else {
                if (!checkSubtypeName || !companySel) {
                    setErrorList([
                        !checkSubtypeName && {
                            field: "checkSubtypeName",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                        !companySel && { field: "companySelId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    ]);
                }
                else {
                    CheckSheetSave(checksheet.sheetType);
                }
            }
        }
        else {
            if (checksheet.sheetType == checksheetName[0]) {
                if (!spgSel || !checkSubtypeName || !company || !checkType || !checkSubtypeNameSel || !versionInfo) {
                    setErrorList([
                        !spgSel && { field: "spgSel", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                        !checkSubtypeName && {
                            field: "checkSubtypeName",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                        !company && { field: "companyId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                        !checkType && { field: "checkType", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                        !checkSubtypeNameSel && {
                            field: "checkSubtypeNameSel",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                        !versionInfo && {
                            field: "checkVersionId",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                    ]);
                }
                else {
                    CheckSheetSave(checksheet.sheetType);
                }
            }
            else {
                if (!spgSel || !checkSubtypeName || !companySel || !checkType || !checkSubtypeNameSel || !versionInfo) {
                    setErrorList([
                        !spgSel && { field: "spgSel", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                        !checkSubtypeName && {
                            field: "checkSubtypeName",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                        !companySel && { field: "companySelId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                        !checkType && { field: "checkType", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                        !checkSubtypeNameSel && {
                            field: "checkSubtypeNameSel",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                        !versionInfo && {
                            field: "checkVersionId",
                            msg: t("라벨.필수항목을입력하지않으셨습니다"),
                        },
                    ]);
                }
                else {
                    CheckSheetSave(checksheet.sheetType);
                }
            }
        }
    }
    //  등록
    function CheckSheetSave(sheetType) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/checksheet/checktype/checksubtype/checkversion/copy`,
                appQuery: {
                    versionIdCopiedFrom: !subType ? null : versionInfo && versionInfo.checkVersionId,
                    companyId: sheetType == checksheetName[0] ? null : company.id,
                    spgName: checksheet.spgName,
                    checktypeName: checksheet.sheetType,
                    checkSubtypeName: checkSubtypeName,
                    description: subMemo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    Close("pop-ss-add");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-ss-add", type: CONST.TYPE_INNRE, divTag: t("라벨.등록완료") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function Close(id) {
        setSubType(false);
        setPopInfo(true);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("ul", Object.assign({ className: "locate" }, { children: _jsx("li", { children: checksheet.sheetType }) })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [checksheet.sheetType == checksheetName[1] && (_jsx("ul", Object.assign({ className: "form__input brd-bottom-1 pb-16 mb-16" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.회사명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select company ${errorList.filter((err) => err.field === "companySelId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popInfo ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CompanyClick(item, 1) }, { children: item.companyName }), "company_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "companySelId").map((err) => err.msg) }))] }))] }) }))), _jsxs("ul", Object.assign({ className: "form__input h424" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세유형명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "inp22", placeholder: t("라벨.텍스트입력"), className: `${errorList.filter((err) => err.field === "checkSubtypeName").length > 0 ? " input-error" : ""}`, value: checkSubtypeName, onChange: (e) => SubTypeChange(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkSubtypeName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "inp23", placeholder: t("라벨.텍스트입력"), value: subMemo, onChange: (e) => setSubMemo(e.target.value) }), _jsxs("div", Object.assign({ className: "flex-inline left-right mt-8" }, { children: [_jsxs("p", Object.assign({ className: "txt-info ml-0" }, { children: ["*", !subType ? t("라벨.저장된체크시트유형내용을복사해올까요") : t("라벨.불러올체크시트를선택")] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic pw-12 bg-no", onClick: (e) => CheckSubType(e) }, { children: _jsx("span", { children: !subType ? `${t("라벨.불러오기")}(${t("라벨.선택")})` : t("라벨.취소") }) }))] }))] }))] }), subType && (_jsxs("li", Object.assign({ className: "mt-32 pb-30" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBD88\uB7EC\uC62C \uCCB4\uD06C\uC2DC\uD2B8 \uC720\uD615" })) })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.회사명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select company ${errorList.filter((err) => err.field === "companyId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: subType ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CompanyClick(item, 2) }, { children: item.companyName }), "company_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "companyId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select spg  ${errorList.filter((err) => err.field === "spgSel").length > 0 ? " input-error" : ""}`, onClick: (e) => 
                                                                            // (checksheet.sheetType == checksheetName[0]
                                                                            //   ? company
                                                                            //   :
                                                                            companySel && SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: spgItem.length <= 0 ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgItem &&
                                                                                        spgItem.map((item, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => SpgSleClick(item) }, { children: item.spgName }), "popSpg_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgSel").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select check  ${errorList.filter((err) => err.field === "checkType").length > 0 ? " input-error" : ""}`, onClick: (e) => spgSel && CheckTypes(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !checkTyped ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkTypeItem &&
                                                                                        checkTypeItem
                                                                                            .filter((non) => non.checkTypeId != 4)
                                                                                            .map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeSub(type) }, { children: type.description }), "type_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkType").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select checkSub ${errorList.filter((err) => err.field === "checkSubtypeNameSel").length > 0
                                                                                ? " input-error"
                                                                                : ""}`, onClick: (e) => checkType && CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !checkSubed ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                                                        checkSubTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(type) }, { children: type.checkSubName }), "subtype_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkSubtypeNameSel").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.버전") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select version ${errorList.filter((err) => err.field === "checkVersionId").length > 0 ? " input-error" : ""}`, onClick: (e) => checkSubtypeNameSel && CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !checkVseioned ? t("라벨.클릭선택") : t("라벨.클릭선택") + " " })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                                                        checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "version_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkVersionId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit mt-0" }, { children: [t("라벨.메모"), " "] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("p", Object.assign({ className: "text" }, { children: description && description })) }))] })] })) }))] })))] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-s-add") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => CheckSheetSaveed(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))] }));
}
function MemePop(props) {
    const t = useTrans();
    //props
    const { memoInfo, setMemoInfo, errorList, setErrorList } = props;
    //recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const sheetInfo = useRecoilValue(checkSheetInfo);
    const [alert, setAlert] = useRecoilState(alertState);
    const [memo, setMemo] = useState(memoInfo);
    useEffect(() => {
        setMemo(memoInfo ? memoInfo : "");
    }, [memoInfo]);
    function MemoUpdate(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/checksheet/checktype/checksubtype/${sheetInfo.checkSubTypeId}`,
                appQuery: {
                    checkSubTypeName: sheetInfo.checkSubTypeName,
                    description: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-memo");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-memo", type: CONST.TYPE_INNRE, divTag: `${memoInfo ? t("라벨.수정되었습니다") : t("라벨.등록완료")} .` }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    // need error handle
                }
            }
        });
    }
    function Close(id) {
        CUTIL.jsclose_Popup(id);
        setMemoInfo(memo ? memo : "");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsx("li", { children: _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: `h170 ${errorList.filter((err) => err.field === "memo").length > 0 ? " input-error" : ""}`, value: memo || "", onChange: (e) => {
                                        setErrorList(errorList.filter((err) => err.field !== "memo"));
                                        setMemo(e.target.value);
                                    }, onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [!memo ? "0" : memo.length, " / 400"] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "memo").map((err) => err.msg) }))] })) }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsxs("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-memo") }, { children: [" ", _jsx("span", { children: t("라벨.취소") })] })), _jsx("button", Object.assign({ type: "button", onClick: (e) => MemoUpdate(e) }, { children: _jsx("span", { children: memoInfo ? t("라벨.수정") : t("라벨.저장") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const sheetInfo = useRecoilValue(checkSheetInfo);
    const [alert, setAlert] = useRecoilState(alertState);
    function SheetDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/checksheet/checktype/checksubtype/checkversion/${sheetInfo.checkversionId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-delete");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_NONE, divTag: sheetInfo.count > 1 ? data.body : t("라벨.체크시트와상세유형항목이삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    // need error handle
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_INNRE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-delete");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.최신버전체크시트삭제", [sheetInfo.versionNo]) }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SheetDelete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
